import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EmailMessage } from '../../../core/services/email-client.types';

@Component({
  selector: 'app-message-view',
  standalone: false,
  templateUrl: './message-view.html',
  styleUrl: './message-view.scss',
})
export class MessageView {
  @Input({ required: true }) message!: EmailMessage;
  @Output() backRequested = new EventEmitter<void>();
  @Output() replyRequested = new EventEmitter<EmailMessage>();
}
